export const SUCCESS_GET_TIMINGS = 'SUCCESS_GET_TIMINGS';
export const FAILED_GET_TIMINGS = 'FAILED_GET_TIMINGS';


// WEBPACK FOOTER //
// ./src/state/constants/timingConstants.js